import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StorageService} from '../../provider/storage/storage.service';

@Component({
	selector: 'app-regisafe-detail-metadata',
	templateUrl: './regisafe-detail-metadata.component.html',
	styleUrls: ['./regisafe-detail-metadata.component.scss'],
})
export class RegisafeDetailMetadataComponent implements OnInit {

	@Input() metadata: Array<any>;
	@Input() details: any;

	constructor(private storageService: StorageService) {
	}

	ngOnInit() {
	}

	preventStatusChange(event) {
		if (event.target.checked) {
			setTimeout(() => {
				event.target.checked = true;
			}, 10);
		} else {
			setTimeout(() => {
				event.target.checked = false;
			}, 10);
		}
	}

}
